import { type SellerRegisterRequestV1 } from '@redteclab/api/clients/bully'
import { type SellerRegistrationV2Dto } from '@redteclab/api/clients/composition-service-marketplace'

import {
  type MarketplacePartnerRegisterPageRequestModelV1,
  type MarketplacePartnerRegisterPageRequestModelV3,
} from '../../marketplacePartnerRegisterPageRequestModels'

const buildBaseRequestBody = (
  model: MarketplacePartnerRegisterPageRequestModelV1,
): SellerRegisterRequestV1 => {
  const filteredBrands = model.brands.filter((brand) => brand.trim() !== '')

  return {
    brands: filteredBrands,
    categories: model.categories,
    companyInformation: {
      additionalAddress: model.additionalAddress,
      city: model.city,
      companyType: model.companyType,
      country: model.country,
      markets: model.markets,
      name: model.name,
      postalCode: model.postalCode,
      streetName: model.streetName,
      streetNumber: model.streetNumber,
      website: model.website,
    },
    contactDetails: {
      email: model.email,
      firstName: model.firstName,
      lastName: model.lastName,
      phoneNumber: model.phoneNumber,
    },
    estimatedRevenue: model.estimatedRevenue,
    fcSolution: model.fcSolution,
    message: model.message,
    middlewarePartnerName: model.middlewarePartnerName,
    productsCount: model.productsCount,
    retailMediaMarketing: model.retailMediaMarketing,
    revenueShare: model.revenueShare,
    shopSystem: model.shopSystem,
  }
}

export const marketplacePartnerRegisterPageBuildRequestBodyFromModel = (
  data: MarketplacePartnerRegisterPageRequestModelV3,
): SellerRegistrationV2Dto => {
  return {
    accountType: data.accountType,
    annualRevenue: data.annualRevenue,
    categories: data.categories,
    company: data.name,
    countryCode: data.countryCode,
    description: data.description,
    email: data.email,
    fcSolution: data.fcSolution,
    firstName: data.firstName,
    interestedInRetailMedia: data.interestedInRetailMedia,
    keyBrand: data.keyBrand,
    lastName: data.lastName,
    marketReadiness: data.marketReadiness,
    phone: data.phoneNumber,
    revenueExpected: data.revenueExpected,
    targetCountries: data.targetCountries,
    vatNumber: data.vatNumber,
    website: data.website,
  }
}

export const marketplacePartnerRegisterPageBuildRequestBodyFromLegacyModelV1 = (
  model: MarketplacePartnerRegisterPageRequestModelV1,
): SellerRegisterRequestV1 => {
  return buildBaseRequestBody(model)
}
